//  ------------------- Common Routes ---------------------
export const HOME = "/";

// Colors
export const COLORS = "/settings/color";

// Collections
export const COLLECTIONS = "/settings/collection";

// Coupons
export const COUPONS = "/settings/coupon";

// Vendor Notifications (product-wise / user-wise)
export const NOTIFICATIONS = "/settings/notification";
export const BANNERS = "/settings/banner";

// Users
export const USERS = "/settings/users";
export const USERS_ADD = "/settings/user/add";
export const USERS_EDIT = "/settings/user/edit/:id";
export const userEditById = (id) => `/settings/user/edit/${id}`;

// Roles & Permissions
export const ROLES = "/settings/roles";
export const ROLES_ADD = "/settings/role/add";
export const ROLES_EDIT = "/settings/role/edit/:id";
export const roleEditById = (id) => `/settings/role/edit/${id}`;
export const MANAGE_PERMISSION = "/settings/manage-permission/:id";
export const managePermission = (id) => `/settings/manage-permission/${id}`;

// Vendors
export const VENDORS = "/vendor";
export const VENDORS_MANAGE_PRICE = "/vendors/manage-price/:id";
export const manageVendorPrice = (id) => `/vendors/manage-price/${id}`;

export const PARTY_RATE = "/product-manager/party-rate";
export const PARTY_RATE_ADD = "/product-manager/party-rate/add";
export const PARTY_RATE_PRODUCT_WISE =
  "/product-manager/party-rate/product-wise";

// Party Number
export const PARTY_NUMBER = "/product-manager/party-number";
export const PARTY_NUMBER_ADD = "/product-manager/party-number/add";

//  ------------------- Office Routes ---------------------

// Products
export const PRODUCTS = "/product-manager/products";
export const ALL_PRODUCTS = "/product-manager/all-products";
export const PRODUCT_ADD = "/product-manager/product/add";
export const PRODUCT_EDIT = "/product-manager/product/edit/:id";
export const productEdit = (id) => `/product-manager/product/edit/${id}`;
export const PRODUCT_VARIANTS = "/product-manager/product/variant/:productId";
export const officeProductVariant = (productId) =>
  `/product-manager/product/variant/${productId}`;
export const PRODUCTS_INWARD = "/product-manager/products-inward";
export const PRODUCTS_INWARD_ADD = "/product-manager/products-inward/add";
export const PRODUCTS_LOW_STOCK = "/product-manager/low-stock";
export const PRODUCTS_PROCESS = "/product-manager/products-process";
export const PRODUCTS_PROCESS_ADD = "/product-manager/products-process/add";
// Product Variants
export const PRODUCT_VARIANT_ADD =
  "/office/product-manager/product-variant/add";
export const PRODUCT_VARIANT_EDIT =
  "/office/product-manager/product-variant/edit/:id";

// Purchase Orders
export const OFFICE_PURCHASE_ORDERS = "/office/purchase-orders";
export const OFFICE_PURCHASE_ORDERS_ADD = "/office/purchase-orders/add";
export const OFFICE_PURCHASE_ADD_FROM_PRE_ORDER =
  "/office/purchase-orders/add/:orderPreBookId";
export const OFFICE_PURCHASE_ORDERS_EDIT = "/office/purchase-orders/edit/:id";
export const addPurchaseOrder = (orderPreBookId) =>
  `/office/purchase-orders/add/${orderPreBookId}`;
export const officePurchaseOrderEdit = (id) =>
  `/office/purchase-orders/edit/${id}`;

// Returns
export const OFFICE_RETURNS = "/office/returns";
export const OFFICE_RETURNS_ADD = "/office/returns/add";
export const OFFICE_RETURNS_EDIT = "/office/returns/edit/:id";
export const OFFICE_RETURN_ADD_FROM_PRE_ORDER =
  "/office/returns/add/:orderPreBookId";
export const officeReturnEdit = (id) => `/office/returns/edit/${id}`;
export const addReturnOrder = (orderPreBookId) =>
  `/office/returns/add/${orderPreBookId}`;

// Invoices
export const OFFICE_INVOICES = "/office/invoices";
export const OFFICE_INVOICE_ADD = "/office/invoice/add";
export const OFFICE_INVOICE_EDIT = "/office/invoice/edit/:id";
export const officeInvoiceEdit = (id) => `/office/invoice/edit/${id}`;
export const OFFICE_INVOICE_Add_From_PO = "/office/invoice/add/:poId";
export const officeInvoiceAddFromPO = (poId) => `/office/invoice/add/${poId}`;
export const OFFICE_ORDER_DISPATCHED = "/office/order/dispatched";
export const OFFICE_ORDER_DISPATCHED_VIEW =
  "/office/order/dispatched/view/:invoiceId";
export const officeOrderDispatchedView = (invoiceId) =>
  `/office/order/dispatched/view/${invoiceId}`;

// Pre-Book Orders
export const OFFICE_PRE_BOOK_ORDERS = "/office/pre-book/orders";
export const OFFICE_PRE_BOOK_ORDERS_ADD = "/office/pre-book/orders/add";
export const OFFICE_PRE_BOOK_ORDERS_EDIT = "/office/pre-book/orders/edit/:id";
export const officePrebookOrderEdit = (id) =>
  `/office/pre-book/orders/edit/${id}`;

//  ------------------- Mill Routes ---------------------

// Products
export const MILL_PRODUCTS = "/mill/products";

// Orders
export const MILL_ORDERS = "/mill/orders";
export const MILL_ORDER_ADD = "/mill/order/add";
export const MILL_ORDER_EDIT = "/mill/order/edit/:id";
export const millOrderEdit = (id) => `/mill/order/edit/${id}`;

// Mill Purchase
export const MILL_PURCHASE = "/mill/purchase";
export const MILL_PURCHASE_ADD = "/mill/purchase/add";
export const MILL_PURCHASE_EDIT = "/mill/purchase/edit/:id";
export const millPurchaseEdit = (id) => `/mill/purchase/edit/${id}`;
export const MILL_PURCHASE_ADD_FROM_KNITTER_ORDER =
  "/mill/purchase/add/:knitterOrderId";
export const addMillPurchaseFromKnitterOrder = (knitterOrderId) =>
  `/mill/purchase/add/${knitterOrderId}`;

// Knitter Order
export const KNITTER_ORDER = "/knitter/order";
export const KNITTER_ORDER_ADD = "/knitter/order/add";
export const KNITTER_ORDER_EDIT = "/knitter/order/edit/:id";
export const knitterOrderEdit = (id) => `/knitter/order/edit/${id}`;

// Logs
export const LOGS_URL = "/logs";

// Lead Management
export const LEADS = "/lead-management/leads";
export const LEAD_DETAIL = "/lead-management/leads/:id";
export const leadDetail = (id) => `/lead-management/leads/${id}`;
